import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import { Testimonial } from '../types';

interface TestimonialsSectionProps {
  testimonials: Testimonial[];
}

const TestimonialsSection = ({ testimonials }: TestimonialsSectionProps) => {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={14}
        className={index < rating ? 'text-teal-700 fill-teal-700' : 'text-[#0C2C39]/10'}
      />
    ));
  };

  return (
    <div className="space-y-12">
      <div className="mb-12">
        <h2 className="text-4xl font-black text-[#0C2C39] mb-4 tracking-tighter font-roboto">Validation <span className="text-teal-700 italic">Reports</span></h2>
        <p className="text-[#0C2C39]/50 text-lg font-medium italic">
          Executive feedback from project stakeholders.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
        {testimonials.map((testimonial) => (
          <div
            key={testimonial.id}
            className="neubrutal-card bg-white p-10 group relative transition-all duration-300"
          >
            {/* Dynamic Quote Icon */}
            <div className="absolute top-8 right-8 text-teal-700/5 group-hover:text-teal-700/10 transition-colors">
              <Icon name="Quote" size={64} />
            </div>

            <div className="flex items-center space-x-5 mb-8 relative z-10">
              <div className="w-16 h-16 rounded-2xl overflow-hidden border-2 border-[#0C2C39] bg-[#FFF9EB] shadow-[3px_3px_0px_0px_#0C2C39]">
                <Image
                  src={testimonial.avatar}
                  alt={testimonial.alt}
                  className="w-full h-full object-cover grayscale transition-all duration-500 group-hover:grayscale-0"
                />
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-black text-[#0C2C39] uppercase tracking-widest">{testimonial.name}</h4>
                <p className="text-[10px] font-black text-teal-700 uppercase tracking-widest mt-1">
                  {testimonial.role} <span className="text-[#0C2C39]/30 mx-1">@</span> {testimonial.company}
                </p>
              </div>
            </div>

            <div className="flex space-x-1 mb-6 relative z-10">
              {renderStars(testimonial.rating)}
            </div>

            <blockquote className="text-[#0C2C39]/60 font-black italic leading-relaxed text-sm relative z-10">
              "{testimonial.message}"
            </blockquote>
          </div>
        ))}
      </div>

      <div className="neubrutal-card bg-teal-700/5 p-8 border-2 border-teal-700/10">
        <div className="flex items-start gap-6">
          <div className="w-14 h-14 bg-white border-2 border-[#0C2C39] text-[#0C2C39] rounded-2xl flex items-center justify-center shadow-[4px_4px_0px_0px_#0C2C39]">
            <Icon name="Shield" size={28} />
          </div>
          <div>
            <h4 className="text-sm font-black text-[#0C2C39] uppercase tracking-widest mb-2">Certified Excellence</h4>
            <p className="text-xs text-[#0C2C39]/50 font-medium leading-relaxed max-w-2xl">
              From disruptive startups to enterprise leaders, I maintain a 98% stakeholder satisfaction rate across 50+ successful deployments.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;